<template>
  <div class="step">
    <div class="step__container">
      <div class="step__header">
        Oplysninger om
        {{ privateAdFlowProductTypeNames.nameSingularParticular }}
      </div>
      <div class="step__text">
        Her skal du skrive din nummerplade. Hvis du ikke kender nummerpladen,
        kan du udvælge din
        {{ privateAdFlowProductTypeNames.nameSingular }} manuelt.
      </div>
      <VariantSelection
        :event-bus="eventBus"
        :initial-designation-lists="initialDesignationLists"
        :initial-license-plate="initialLicensePlate"
        :product-type-id="productTypeId"
        :private-ad-flow-product-type-names="privateAdFlowProductTypeNames"
        ref="variantSelectionComponent"
      ></VariantSelection>
    </div>
    <StepButtonPanel
      :event-bus="eventBus"
      :next-visible="true"
      :next-enabled="true"
      :validate-function="validate"
    ></StepButtonPanel>
  </div>
</template>
<script>
import StepButtonPanel from '../Components/StepButtonPanel/StepButtonPanel.vue'
import VariantSelection from '../Components/VariantSelection/VariantSelection.vue'

export default {
  components: {
    StepButtonPanel,
    VariantSelection,
  },
  props: {
    eventBus: { default: null, type: Object },
    initialDesignationLists: { default: null, type: Array },
    initialLicensePlate: { default: '', type: String },
    productTypeId: { default: null, type: Number },
    variant: { default: null, type: Object },
    privateAdFlowProductTypeNames: {
      default: () => {
        return {}
      },
      type: Object,
    },
  },
  data() {
    return {
      isValid: false,
    }
  },
  methods: {
    validate() {
      if (!this.isValid) {
        this.$refs.variantSelectionComponent.isValid()

        return false
      }

      return true
    },
  },
  watch: {
    variant: {
      handler(obj) {
        if (obj != null && obj.id != null) {
          if (obj.id !== 0) {
            this.isValid = true
          } else {
            this.isValid = false
          }
        } else {
          this.isValid = false
        }
      },
    },
  },
  mounted() {
    this.eventBus.emit('stepLoaded', 1)
  },
}
</script>

<style lang="scss">
@import 'Step.scss';
</style>
